const PATIENT_ID_FIELDS = [
  "patientId",
  "userId",
  "id",
  "_id",
  "uuid",
  "externalId",
  "identifier",
  "patientIdentifier",
];

const normalizeIdentity = (value) => {
  const normalized = String(value ?? "").trim().toLowerCase();
  return normalized || null;
};

export const medicalAccessTargetKey = (patientId, subprofileId) =>
  `${String(patientId ?? "").trim()}::${String(subprofileId ?? "principal").trim()}`;

const getPatientIdentityKeys = (patient) =>
  Array.from(
    new Set(
      PATIENT_ID_FIELDS.map((field) => normalizeIdentity(patient?.[field])).filter(Boolean)
    )
  );

const hasMeaningfulValue = (value) =>
  value !== null && value !== undefined && value !== "";

const mergePatient = (current, incoming) => {
  const merged = { ...current };

  Object.entries(incoming || {}).forEach(([field, value]) => {
    if (hasMeaningfulValue(value)) merged[field] = value;
  });

  return merged;
};

export const mergeUniquePatients = (...collections) => {
  const records = [];
  const recordByIdentity = new Map();

  collections.flat().filter(Boolean).forEach((patient) => {
    const identityKeys = getPatientIdentityKeys(patient);
    const matchingRecords = Array.from(
      new Set(identityKeys.map((key) => recordByIdentity.get(key)).filter(Boolean))
    );

    if (matchingRecords.length === 0) {
      const record = { value: { ...patient } };
      records.push(record);
      identityKeys.forEach((key) => recordByIdentity.set(key, record));
      return;
    }

    const target = matchingRecords[0];
    matchingRecords.slice(1).forEach((duplicate) => {
      target.value = mergePatient(target.value, duplicate.value);
      const duplicateIndex = records.indexOf(duplicate);
      if (duplicateIndex !== -1) records.splice(duplicateIndex, 1);
      recordByIdentity.forEach((record, key) => {
        if (record === duplicate) recordByIdentity.set(key, target);
      });
    });

    target.value = mergePatient(target.value, patient);
    identityKeys.forEach((key) => recordByIdentity.set(key, target));
  });

  return records.map((record) => record.value);
};
